import React from 'react';
import { Button } from '@mui/material';
import { GridToolbarContainer } from '@mui/x-data-grid';
import AddIcon from '@mui/icons-material/Add';

/**
 * Shared DataGridPro toolbar component with an "Add" button.
 * Replaces the EditToolbar functions that were duplicated in
 * HoldTable, SupplierTable, MarketTable, and ShipTable.
 *
 * @param {string}   label - Button text (e.g. "Add Hold", "Add Ship")
 * @param {Function} onAdd  - Click handler for adding a new row
 */
const AddRowToolbar = ({ label, onAdd }) => (
  <GridToolbarContainer>
    <Button color='primary' startIcon={<AddIcon />} onClick={onAdd}>
      {label}
    </Button>
  </GridToolbarContainer>
);

export default AddRowToolbar;
